import { atom } from 'jotai';

export type CurrentCategoryType =
    | 'All'
    | 'Projects'
    | 'Products'
    | 'Archizeen'
    | 'Professionals'
    | 'Rooms'
    | 'Builders'
    | 'Architects'
    | 'Home Design Evening'
    | null;

/**
 * Atom to store and manage the current category state.
 * This is used to determine which navigation category should be highlighted as active.
 * Should be updated when navigating between different category pages.
 */
export const currentCategoryAtom = atom<CurrentCategoryType>(null);
